import type { AwardBadgeCategory } from '@gyym/ui'

import { AWARDED_FACILITIES_BY_YEAR } from './constants'
import type { AwardCategory, AwardedFacility, FacilityAward } from './types'

/**
 * 受賞施設マスタから施設の最新年度の受賞情報を取得する
 * (複数年度で受賞している場合は最新年度のみ返す)
 */
export const findLatestFacilityAward = (
  awardedFacilitiesByYear: Record<number, AwardedFacility[]>,
  facilityId: number,
): FacilityAward | undefined => {
  const years = Object.keys(awardedFacilitiesByYear)
    .map(Number)
    .sort((a, b) => b - a)

  for (const year of years) {
    const categories = (awardedFacilitiesByYear[year] ?? [])
      .filter((facility) => facility.facilityId === facilityId)
      .map((facility) => facility.category)

    if (categories.length > 0) {
      return { year, categories }
    }
  }

  return undefined
}

/** 施設の最新年度の受賞情報 (未受賞は undefined) */
export const getFacilityAward = (
  facilityId: number,
): FacilityAward | undefined =>
  findLatestFacilityAward(AWARDED_FACILITIES_BY_YEAR, facilityId)

/** 施設カードの受賞マーク表示用: 最新の受賞年度 (未受賞は undefined) */
export const getFacilityAwardYear = (facilityId: number): number | undefined =>
  getFacilityAward(facilityId)?.year

/**
 * 受賞部門を AwardBadge の部門へ変換する
 * (BEST GYM / BEST STUDIO はバッジ上の表記・エンブレムが統合のため重複を除去)
 */
export const toAwardBadgeCategories = (
  categories: AwardCategory[],
): AwardBadgeCategory[] => {
  const badgeCategories = categories.map((category): AwardBadgeCategory => {
    switch (category) {
      case 'BEST GYM':
      case 'BEST STUDIO':
        return 'bestGymStudio'
      case 'BEST COMMUNITY':
        return 'bestCommunity'
      case 'RISING STAR':
        return 'risingStar'
    }
  })

  return [...new Set(badgeCategories)]
}
